import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class HisBrowserDetectionService {

    browserName: string = undefined;
    browserVersion: string = undefined;

    // better apt for comparisons
    majorVersion: number;
    minorVersion: string;

    constructor() {
    }

    public detectBrowser() {
        let ua = window.navigator.userAgent;
        console.log( 'HisBrowserDetectionService.detectBrowser(): userAgent =', ua );
        this.detectNameAndVersion( ua );
        if ( this.browserName && this.browserVersion ) {
            // detection was successful
            this.deriveMajorAndminorVersion();
            console.log( 'HisBrowserDetectionService.detectBrowser(): Detected ' + this.browserName + ' '
                + this.browserVersion + ' (majorVersion = ' + this.majorVersion + ', minorVersion = ' + this.minorVersion + ')' );
        } else {
            console.warn( 'HisBrowserDetectionService.detectBrowser(): Browser detection failed' );
        }
    }

    private detectNameAndVersion( ua: string ) {
        // detect browser name and version
        // Microsoft browsers following https://codepen.io/gapcode/pen/vEJNZN
        let msie = ua.indexOf( 'MSIE ' );
        if ( msie > 0 ) {
            // IE 10 or older: ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
            this.browserName = 'IE';
            this.browserVersion = ua.substring( msie + 5, ua.indexOf( ';', msie ) );
            return;
        }

        let trident = ua.indexOf( 'Trident/' );
        if ( trident > 0 ) {
            // IE 11: ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
            this.browserName = 'IE';
            let rv = ua.indexOf( 'rv:' );
            this.browserVersion = ua.substring( rv + 3, ua.indexOf( ')', rv ) );
            return;
        }

        // Edge must be checked before Chrome and Safari because its userAgent string contains both of them.
        // Old Edge:
        let edge = ua.indexOf( 'Edge/' );
        if ( edge > 0 ) {
            // Edge (IE 12+)
            // Edge 12: ua = 'Mozilla/5.0
            //   (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
            // Edge 13: ua = 'Mozilla/5.0
            //   (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';
            this.browserName = 'Edge';
            this.browserVersion = ua.substring( edge + 5 );
            return;
        }

        // Edge-Chromium
        let edgeChromium = ua.indexOf( 'Edg/' );
        if ( edgeChromium > 0 ) {
            // Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko)
            // Chrome/83.0.4103.116 Safari/537.36 Edg/83.0.478.58
            this.browserName = 'Edge-Chromium';
            this.browserVersion = ua.substring( edgeChromium + 4 );
            return;
        }

        let ff = ua.indexOf( 'Firefox/' );
        if ( ff > 0 ) {
            // Firefox: ua = Mozilla/5.0 (Windows NT 6.3; WOW64; rv:59.0) Gecko/20100101 Firefox/59.0
            this.browserName = 'Firefox';
            this.browserVersion = ua.substring( ff + 8 );
            return;
        }

        // Chrome must be checked before Safari ?
        let chrome = ua.indexOf( 'Chrome/' );
        if ( chrome > 0 ) {
            // Chrome: Mozilla/5.0 (Windows NT 6.3; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/65.0.3325.181 Safari/537.36
            this.browserName = 'Chrome';
            this.browserVersion = ua.substring( chrome + 7, ua.indexOf( ' ', chrome ) );
            return;
        }

        // TODO: Test Safari
    }

    private deriveMajorAndminorVersion() {
        // console.log( 'browserVersion =', this.browserVersion );
        let dotIndex = this.browserVersion.indexOf( '.' );
        this.majorVersion = parseInt( this.browserVersion.substring( 0, dotIndex ), 10 );
        this.minorVersion = this.browserVersion.substring( dotIndex + 1 );
    }
}
